import { ReactComponent as RessoColorLight } from 'fym-shared/src/music-services/assets/images/resso-color-light.svg';
import { ReactComponent as RessoColorDark } from 'fym-shared/src/music-services/assets/images/resso-color-dark.svg';
import { ReactComponent as RessoColorLightPadding } from 'fym-shared/src/music-services/assets/images/resso-color-light-padding.svg';
import { ReactComponent as RessoColorDarkPadding } from 'fym-shared/src/music-services/assets/images/resso-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const ressoImages: MusicServiceImages = {
  logoColor: {
    light: RessoColorLight,
    dark: RessoColorDark,
  },
  logoColorPadding: {
    light: RessoColorLightPadding,
    dark: RessoColorDarkPadding,
  },
};
